import React from 'react';
import { withRouter } from 'react-router-dom';

export const LoginRedirect: React.FC<any> = ({ location, redirect }) => {
  /*
    XXX:
    `location.assign` is used here to preserve the referrer after a redirect.
    The referrer is used by the Login component to prevent a user from getting stuck in
    a redirect loop in the edge case that they aren't authorised to view to page
    specified in the `next` param.
  */
  window.location.assign(redirect || `/login?next=${location.pathname}`);

  return null;
};

export const LoginRedirectWithRouter = withRouter(LoginRedirect);
